import { useState } from 'react';
import queryString from 'query-string';
import moment from 'moment';

import { checkPassword } from 'old-store/actions';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { getTranslationKey } from 'helpers/texting';

const asString = (value: string | string[] | null | undefined): string =>
  Array.isArray(value) ? value[0] || '' : value || '';

export interface IPasswordPageState {
  title: string;
  design: any;
  password: string;
  setPassword: (value: string) => void;
  handlePasswordCheck: (event: React.FormEvent<HTMLFormElement | HTMLButtonElement>) => void;
  areCookiesEnabled: boolean;
  isWrongPassword: boolean;
  lockedUntil: string;
  lockedUntilText: string;
}

export const usePasswordPage = (): IPasswordPageState => {
  const dispatch = useAppDispatch();
  const [password, setPassword] = useState('');
  const { title, design } = useAppSelector((state) => state.collection);

  const { pw, locked_until: rawLockedUntil } = queryString.parse(window.location.search);
  const lockedUntil = asString(rawLockedUntil);

  const handlePasswordCheck = (event: React.FormEvent<HTMLFormElement | HTMLButtonElement>) => {
    event.preventDefault();

    dispatch(checkPassword(window.SITE_ID, password));
  };

  return {
    title,
    design,
    password,
    setPassword,
    handlePasswordCheck,
    areCookiesEnabled: window.navigator.cookieEnabled,
    isWrongPassword: asString(pw) === 'wrong',
    lockedUntil,
    lockedUntilText: lockedUntil
      ? getTranslationKey('singInLockedUntil').replace(
          '{{until}}',
          moment(lockedUntil).add(1, 'm').format('DD.MM.YY - HH:mm')
        )
      : ''
  };
};
